import React, { useEffect } from 'react';
import cn from 'classnames';
import { useElapsedTime } from 'use-elapsed-time';
import { SliderButton } from 'components/UI';

import * as styles from './SliderControl.module.scss';

export default function SliderControl({
  className,
  interval = 6,
  current,
  to,
  handleNext,
  handlePrev,
  theme,
}) {
  const { elapsedTime, reset } = useElapsedTime({ isPlaying: true, duration: interval });

  useEffect(() => {
    if (elapsedTime === interval) {
      handleNext();
      reset();
    }
  }, [elapsedTime]);

  useEffect(() => {
    reset();
  }, [current]);

  return (
    <div className={cn(styles.controlsWrapper, className)}>
      <div className={styles.buttonsWrapper}>
        {current && to && (
          <div className={cn(styles.text, styles[theme])}>{`${current} of ${to}`}</div>
        )}
        <SliderButton className={styles.button} handleClick={handlePrev} back />
        <SliderButton
          className={styles.button}
          handleClick={handleNext}
          value={elapsedTime}
          max={interval}
        />
      </div>
    </div>
  );
}
